import { useEffect, useState } from "react";
import MaterialTable, { MTableBody, MTableToolbar } from "material-table";
import {
  Box,
  Grid,
  Button,
  Typography,
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent,
  DialogActions,
  FormControl,
  CircularProgress,
  Divider,
  Tooltip,
} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";
import {
  GetExitDailyWagesPaySummaryHelper,
  UpdateExitPayrollApproverStatusHelper,
} from "../../../helper/PayEcms/PayEcmsRunHelper";
import CommonDatePicker from "../../../../Base/views/CommonDatePicker";
import PayrunApprovedWorkBased from "./PayrunApprovedWorkbased";
import SelectableMultiSelect from "../../../../Base/views/SelectableMultiSelect";

const PayrunWorkBasedApproval = () => {
  const dispatch = useDispatch();
  const date = new Date();
  const { minDojYear } = useSelector(
    (state) => state?.AncillaryReducer?.WorkSpaceDojReducer
  );
  const [dailyWageReportData, setDailyWageReportData] = useState([]);
  const [dailyWageReportCompletedData, setDailyWageReportCompletedData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const fetchData = async (monthVal, yearVal) => {
    try {
      setIsLoading(true);
      const [f_year, month] = filters.month_year.split("-");
      const f_month = parseInt(month, 10).toString();
      const locationPayload = JSON.stringify((filters?.ats_work_location_id || [])?.map((item) => ({ ats_work_location_id: item?.work_location_id })));
      const resRec = await GetExitDailyWagesPaySummaryHelper({
        employee_fk: null,
        month: monthVal || f_month,
        year: yearVal || f_year,
        ats_work_location_json: (filters?.ats_work_location_id || [])?.length > 0 ? locationPayload : null,
      });
      if (resRec?.data?.statuscode === 200) {
        const resData = resRec?.data?.data;
        if (resData?.length > 0) {
          setDailyWageReportData(resData?.filter(item => item?.status !== "Approved" && item?.status !== "Rejected"));
          setDailyWageReportCompletedData(resData?.filter(item => item?.status === "Approved" || item?.status === "Rejected"));
        }
        setIsLoading(false);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const [updateStatus, setUpdateStatus] = useState("");
  const [openDialog2, setOpenDialog2] = useState(false);
  const [filters, setFilters] = useState({
    month_year: `${date.getFullYear()}-${
      date.getMonth() + 1
    }-${date.getDate()}`,
    ats_work_location_id: []
  });
  const handleFilter = (event) => {
    if (["month_year"].includes(event?.target?.name)) {
      const updatedFilters = {
        ...filters,
        [event?.target?.name]: event?.target?.value,
      };
      setFilters(updatedFilters);
    }
  };
  const handleSelect = (rows) => {
    setSelectedRows(rows);
  };
  const handleStatusChange = (status) => {
    setUpdateStatus(status);
    setOpenDialog2(true);
  };
  const handleUpdateApproverStatus = () => {
    const [f_year, month] = filters.month_year.split("-");
    const f_month = parseInt(month, 10).toString();
    const id = selectedRows?.map((item) => item.employee_fk);
    setIsButtonLoading(true);
    UpdateExitPayrollApproverStatusHelper({
      status: updateStatus, // Approved/Rejected
      payroll_type: "work-based", // regular / work-based
      employee_fk: id?.length ? `{${id}}` : ``,
      month: f_month,
      year: f_year,
    }).then((res) => {
      if(res?.data?.statuscode === 200){
        fetchData();
        setOpenDialog2(false);
      }
      setIsButtonLoading(false);
    });
  };
  const { workLocationAccess_options } = useSelector(state => state?.AncillaryReducer?.WorkLocationReducer);
  const [worklocationData, setWorklocationData] = useState({
                load: true,
                values: [],
            });
  const handleWorkLoacation = () => {
      if(workLocationAccess_options) {
          setWorklocationData({ load: false, values: workLocationAccess_options || [] })
      } else {
          setWorklocationData({ load: false, values: [] })
      }
  }
  useEffect(() => {
      handleWorkLoacation();
      // eslint-disable-next-line react-hooks/exhaustive-deps
  },[workLocationAccess_options])
  const handleFilterChange = (event, value) => {
    if (["ats_work_location_id"].includes(event)) {
      if (value) {
          setFilters({ ...filters, [event]: value });
      } else {
          setFilters({ ...filters, [event]: "" });
      }
    }
  };
  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, filters]);
  const tableTitle = (
    <Box>
      <Typography variant="h6" fontWeight={600}>
        Employee
      </Typography>
      <Typography variant="body2" fontWeight={500}>
        Action Needed
      </Typography>
    </Box>
  );
  return (
    <Box sx={{ overflowY: "auto" }}>
    <Box>
      <Grid
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "space-between",
        }}
        pt={1.5}
        pb={1}
        container
      >
        <Grid pr={1} item xs={12} sm={2.5}>
          <FormControl fullWidth>
            <CommonDatePicker
              name="month_year"
              openTo="month"
              views={["year", "month"]}
              label="Month and Year"
              pickerType="date"
              size="small"
              onKeyDown={(e) => e.preventDefault()}
              onKeyPress={(e) => e.preventDefault()}
              pickerFormat="MM/yyyy"
              DefaultDTvalue={filters.month_year}
              // minDate={new Date(new Date(minDojYear).getFullYear(), 0, 31)}
              minDate={new Date(new Date(minDojYear).setFullYear(new Date(minDojYear).getFullYear() - 1))}
              maxDate={
                new Date(new Date().getFullYear(), new Date().getMonth() + 2, 1)
              }
              handleChange={(value) =>
                handleFilter({
                  target: {
                    name: "month_year",
                    value: value
                      ? `${value?.getFullYear()}-${(
                          "0" +
                          (value?.getMonth() + 1)
                        ).slice(-2)}-${("0" + value?.getDate()).slice(-2)}`
                      : "",
                  },
                })
              }
            />
          </FormControl>
        </Grid>
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            pr: 2,
            mb: 1,
          }}
        >
          <Tooltip
            title={
              dailyWageReportData?.length === 0 ? "" : selectedRows?.length === 0
                ? "Select employee to approve"
                : ""
            }
            arrow
          >
            <Box>
              <Button
                onClick={() => handleStatusChange("Approved")}
                className="mpl-primary-btn"
                color="success"
                sx={{ ml: 1 }}
                disabled={
                  dailyWageReportData?.length === 0 || selectedRows?.length === 0
                }
              >
                Approve
              </Button>
             
            </Box>
          </Tooltip>
          <Tooltip
            title={
              dailyWageReportData?.length === 0 ? "" : selectedRows?.length === 0
                ? "Select employee to reject"
                : ""
            }
            arrow
          >
            <Box>
                <Button
                  onClick={() => handleStatusChange("Rejected")}
                  className="mpl-primary-btn"
                  color="error"
                  sx={{ ml: 1 }}
                  disabled={
                    dailyWageReportData?.length === 0 || selectedRows?.length === 0
                  }
                >
                  Reject
              </Button>
            </Box>
          </Tooltip>
        </Box>
      </Grid>
      <Box>
        <MaterialTable
          isLoading={isLoading}
          columns={[
            {
              title: "Employee No",
              headerStyle: {
                width: "12%",
                padding: "0px 0px 0px 5px",
                textAlign: "start",
              },
              cellStyle: {
                width: "12%",
                textAlign: "start",
                padding: "10px 0px 5px 5px",
              },
              field: "employee_no",
            },
            {
              title: "Employee Name",
              headerStyle: {
                width: "15%",
                padding: "0px 0px 0px 5px",
                textAlign: "start",
              },
              cellStyle: {
                width: "15%",
                textAlign: "start",
                padding: "0px 0px 0px 5px",
              },
              field: "employee_name",
            },
             {
                title: "Work Location",
                field: "work_location_name",
                headerStyle: {
                  width: "12%",
                  padding: "0px 0px 0px 5px",
                  textAlign: "start",
                },
                cellStyle: {
                  width: "12%",
                  textAlign: "start",
                  padding: "10px 0px 5px 5px",
                },
                render: (rowData) => rowData?.work_location_name || "N/A"
            },
            {
              title: "DOJ",
              field: "doj",
              align: "center",
              headerStyle: {
                width: "9%",
                padding: "0px 0px 0px 5px",
                textAlign: "start",
              },
              cellStyle: {
                width: "9%",
                textAlign: "start",
                padding: "0px 0px 0px 5px",
              },
            },
            {
              title: "Days In Month",
              field: "days_in_a_month",
              headerStyle: {
                width: "12%",
                padding: "0px 0px 0px 5px",
                textAlign: "start",
              },
              cellStyle: {
                width: "12%",
                textAlign: "start",
                padding: "0px 0px 0px 3%",
              },
            },
            {
              title: "Actual Working Days",
              field: "actual_working_days",
              headerStyle: {
                width: "12%",
                padding: "0px 0px 0px 5px",
                textAlign: "start",
              },
              cellStyle: {
                width: "12%",
                textAlign: "start",
                padding: "0px 0px 0px 3%",
              },
            },
            {
              title: "Total Earnings",
              field: "total_earnings",
              headerStyle: {
                width: "12%",
                padding: "0px 0px 0px 5px",
                textAlign: "start",
              },
              cellStyle: {
                width: "12%",
                textAlign: "start",
                padding: "0px 0px 0px 2%",
              },
              render: (rowData) => rowData?.total_earnings || 0,
            },
            {
              title: "Total Deductions",
              field: "total_deductions",
              headerStyle: {
                width: "14%",
                padding: "0px 0px 0px 5px",
                textAlign: "start",
              },
              cellStyle: {
                width: "14%",
                textAlign: "start",
                padding: "0px 0px 0px 2%",
              },
              render: (rowData) => rowData?.total_deductions || 0,
            },
            {
              title: "Net Salary",
              field: "net_salary",
              headerStyle: {
                width: "10%",
                padding: "0px 0px 0px 5px",
                textAlign: "start",
              },
              cellStyle: {
                width: "10%",
                textAlign: "start",
                padding: "0px 0px 0px 2%",
              },
              render: (rowData) => rowData?.net_salary || 0,
            },
          ]}
          data={dailyWageReportData || []}
          options={{
            maxBodyHeight: 320,
            minBodyHeight: 320,
            maxWidth: "80vh",
            rowStyle: { fontSize: "13px" },
            headerStyle: { padding: "5px 0px 5px 0px", fontWeight: "bold" },
            cellStyle: { height: "35px" },
            sorting: true,
            search: true,
            searchFieldAlignment: "right",
            searchAutoFocus: false,
            filtering: false,
            paging: true,
            pageSizeOptions: [25, 50],
            pageSize: 25,
            selection: true,
            actionsColumnIndex: -1,
            showSelectAllCheckbox: true,
            showTextRowsSelected: true,
            grouping: false,
            columnsButton: false,
            showTitle: true,
          }}
          components={{
            Body: (props) =>
              dailyWageReportData?.length === 0 ? (
                <tbody>
                  <tr>
                    <td colSpan={props.columns.length}>
                      <Box
                        sx={{
                          height: 320,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "#888",
                          fontSize: "16px",
                        }}
                      >
                        Pay summary report not generated for this month-year
                        selection.
                      </Box>
                    </td>
                  </tr>
                </tbody>
              ) : (
                <MTableBody {...props} />
              ),
            Toolbar: (props) => (
              <Box sx={{ width: "full", display: "flex", flexDirection: { xs: "column", sm: "row" }, flexGrow: 1 }}>
                  <Box
                      sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      backgroundColor: "#f3edfd",
                      padding: "0px 0px 0px 20px",
                      flexGrow: 1,
                      minHeight: "48px !important",
                      }}
                  >
                  <Box>
                      <Typography variant='h6'>
                          {tableTitle}
                      </Typography>
                  </Box>
                  <Box sx={{width: "210px", display: "flex", alignItems: "center", pt: 0.5}}>
                      <SelectableMultiSelect
                          multiple
                          label="Work Location"
                          placeholder="Select Location"
                          value={filters?.ats_work_location_id}
                          loading={handleWorkLoacation}
                          fieldLabel="work_location_name"
                          name="ats_work_location_id"
                          size="small"
                          onChangeEvent={handleFilterChange}
                          data={worklocationData}
                          menuHeight={150} // optional
                      />
                  </Box> 
                  </Box>
                  <Box
                      sx={{
                          "& .MuiToolbar-root": {
                          padding: "14px 16px !important",
                          margin: "auto !important",
                          minHeight: "48px !important",
                          },
                          "& .MuiFormControl-root": {
                          margin: "0 !important",
                          },
                          "& .MuiInputBase-root": {
                          marginLeft: "-40px !important",
                          }
                      }}
                      >
                          <MTableToolbar {...props} />
                      </Box>
                  </Box>
          ),
          }}
          onSelectionChange={handleSelect}
          title={""}
        />
      </Box>

      <Dialog
        open={openDialog2}
        onClose={() => setOpenDialog2(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          Confirm Action
          <IconButton onClick={() => setOpenDialog2(false)} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Typography>
            {`Are you sure you want to ${
              updateStatus === "Approved"
                ? "approve"
                : updateStatus === "Rejected"
                ? "reject"
                : ""
            }?`}
          </Typography>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            onClick={handleUpdateApproverStatus}
            color={updateStatus === "Rejected" ? "error" : "primary"}
            variant="outlined"
            disabled={isButtonLoading}
            startIcon={isButtonLoading ? <CircularProgress size={18} color="inherit" /> : null}
          >
            {updateStatus === "Approved"
              ? "Approve"
              : updateStatus === "Rejected"
              ? "Reject"
              : ""}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
    <Divider sx={{marginTop: 2}} />
    <PayrunApprovedWorkBased dailyWageReportCompletedData= {dailyWageReportCompletedData} isLoading={isLoading}
        filters={filters}
        handleFilterChange={handleFilterChange}
        handleWorkLoacation={handleWorkLoacation}
        worklocationData={worklocationData}
    />
    </Box>
  );
};

export default PayrunWorkBasedApproval;
